const empty = {
  presence: {
    allowEmpty: false,
    message: 'require'
  }
}
const Constraints = {
  airportId: empty,
}

const table = {
  parkingSlotNameEN: empty,
  parkingSlotNameTH: empty,
}

module.exports = {
  Constraints,
  table
}